export const InitializationEndpoints = {
  createSystemInitialConfig: '/public/initialization/setup',
  createSystemData: '/public/initialization/data',
}
